/**
 * MetaRouteAnalytics — SPA PageView + consent bootstrap (iter101)
 * ───────────────────────────────────────────────────────────────
 * Mounted once inside the Router. Fires a single Meta `PageView` on
 * every route change (path + search), loads the Pixel when consent is
 * granted, and re-fires PageView the moment the user accepts cookies.
 * Renders nothing.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMeta, initMetaPixel, metaTrackingAllowed } from '../lib/metaTracking';

const MetaRouteAnalytics = () => {
  const location = useLocation();

  // Boot: load the pixel if consent already granted this session.
  useEffect(() => { initMetaPixel(); }, []);

  // One PageView per SPA route change.
  useEffect(() => {
    if (metaTrackingAllowed()) trackMeta('PageView');
  }, [location.pathname, location.search]);

  // React to the cookie banner: load + PageView on accept.
  useEffect(() => {
    const onChange = () => {
      if (metaTrackingAllowed()) {
        initMetaPixel();
        trackMeta('PageView');
      }
    };
    window.addEventListener('cookieconsent-change', onChange);
    return () => window.removeEventListener('cookieconsent-change', onChange);
  }, []);

  return null;
};

export default MetaRouteAnalytics;
